<template>
  <v-app id="inspire" class="background-svg">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs11 sm6 md4>
            <v-card class="elevation-12 pb-10 px-4 pt-5" min-width="400">
              <v-card-title
                class="text-center d-flex flex-column justify-center"
              >
                <div class="justify-center">
                  <v-img
                    :src="API_BASE_URL+'/web_front/icon_logo.svg'"
                    class="logo-svg"
                  ></v-img>
                </div>
                <br />
                <div>
                  <span>Reset Password</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="user.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    label="New Password"
                    @click:append="showPassword = !showPassword"
                    id="password"
                    name="password"
                    outlined
                    dense
                    v-validate="'required'"
                    :error="
                      errors.first('password') != null ||
                      serverSideErrors.password != null
                    "
                    :error-messages="
                      errors.first('password') || serverSideErrors.password
                    "
                  ></v-text-field>
                  <v-text-field
                    v-model="user.password_confirmation"
                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    label="Confirm Password"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    id="Confirm Password"
                    name="Confirm Password"
                    outlined
                    dense
                    v-validate="'required'"
                    :error="
                      errors.first('Confirm Password') != null ||
                      serverSideErrors.password_confirmation != null
                    "
                    :error-messages="
                      errors.first('Confirm Password') || serverSideErrors.password_confirmation
                    "
                  ></v-text-field>
                </v-form>
              </v-card-text>
                <v-row>
                  <v-col cols="12" class="px-6">
                    <v-btn block color="primary" @click="resetPassword" :loading="loading"> Reset Password </v-btn>
                  </v-col>
                </v-row>
            </v-card>
          </v-flex>
          <Alert />
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Alert from "../../Alert.vue";
import "@/assets/style.css";
import { mapMutations } from "vuex";

export default {
  components: {
    Alert,
  },
  data() {
    return {
      showPassword: false,
      showConfirmPassword: false,
      user: {
        password: "",
        password_confirmation: "",
      },
      loading: false,
      token: '',
      serverSideErrors: {}
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    resetPassword() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;

          _self.$axios.post("/superadmin/resetPassword/"+this.token, this.user).then((response) => {
            let data = response.data;
            _self.loading = false;
            _self.serverSideErrors = {};

            if (data.status) {
              _self.setAlert({
                showAlert: true,
                variant: "green accent-4",
                timeout: "2000",
                message: data.message,
              })
              this.$router.push({ path: "/superadmin/login" });
            } else {
              if (data.errors) {
                for (let i = 0; i < data.errors.length; i++) {
                  _self.serverSideErrors[data.errors[i].field] = data.errors[i].message;
                }
              } else {
                this.setAlert({
                  showAlert: true,
                  variant: "red accent-3",
                  timeout: "2000",
                  message: data.message,
                });
              }
            }
          });
        }
      });
    },
  },
  mounted() {
    this.token = this.$route.params.token;
  }
};
</script>

<style scoped>
.background-svg {
  background: url("http://127.0.0.1:3333/web_front/icon_bulding.svg") !important;
  background-size: 100% 100% !important;
}

.logo-svg {
  width: 150px !important;
}
</style>